import {
  Notifications,
} from '@material-ui/icons';
import { ccTypes } from 'store/constant';
import paths from 'paths';

export default {
  id: 'notifications-menu',
  type: 'group',
  children: [
    {
      id: 'notifications',
      title: 'Notifications',
      type: 'item',
      url: `${paths.notifications.reverse()}?isReaded=no`,
      icon: Notifications,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.internal],
    },
  ],
};
